const palette = {
    custom: {
        primaryGreen: '#38CFAB',
        primaryBlue: '#4F6C8D',
        secondaryGreen: '#92F7DF',
        secondaryBlue: '#E0FBFF',
        backgroundSection: '#F3F4F6',
        backgroundBorder: '#E3E3E3',
        backgroundButton: '#F0F0F0',
        backgroundWhite: '#FFFFFF',
        primaryTextGrey: '#504949',
        secondaryTextGrey: '#999999',
        whiteBackground:'#FFFFFF',
        primaryYellow: '#CA8A04',
        secondaryYellow: '#FEFCE8'
    },
    error: {
        main: '#FF6565',
    },
};

export default palette;
